import React from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import OrderDetail from '../../components/OrderDetail'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import _ from 'lodash'

function OrderDetailScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { orderStore, navigation, route } = props
    const { orderId } = route.params
    const [isLoading, setIsLoading] = React.useState(true)

    React.useEffect(() => {
        const focus = navigation.addListener('focus', async () => {
            try {
                await orderStore.getOrder(orderId)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        })
        return focus
    }, [navigation])

    const handleOnUpdateStatusPress = async (value) => {
        try {
            await orderStore.updateOrderStatus(orderId, value)
        }
        catch (e) {
            console.log(e)
        }
    }

    const handleOnReservationUpdateStatusPress = async (reservationId, value) => {
        try {
            await orderStore.updateReservationStatus(orderId, reservationId, value)
        }
        catch (e) {
            console.log(e)
        }
    }

    if (isLoading) {
        return <Loading />
    }

    console.log(toJS(orderStore.order))

    return (
        <OrderDetail
            t={t}
            order={toJS(orderStore.order)}
            onUpdateStatusPress={(value) => handleOnUpdateStatusPress(value)}
            onReservationUpdateStatusPress={(reservationId, value) => handleOnReservationUpdateStatusPress(reservationId, value)}
            onTrackingPress={(trackingNumber) => console.log('trackingNumber')}
        />
    )
}

export default inject('orderStore')(observer(OrderDetailScreen))